import React from "react";
import { useParams } from "react-router-dom";
import CentersCard from "../components/CentersCard.js";
import NonProfitCard from "../components/NonProfitCard.js";
import "./Pages.css";
import Map from "../components/Map";

export default function CountyDetailPage() {
  const { id } = useParams();
  const [data, setData] = React.useState();
  const [centerConnections, setCenterConnections] = React.useState([]);
  const [nonprofitConnections, setNonprofitConnections] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_FLASK_URL}/texascounties/${id}`
        );
        const data = await response.json();
        setData(data[0]);
      } catch (error) {
        console.error("Error fetching rows:", error);
      }
    };

    fetchData();
  }, [id]);

  React.useEffect(() => {
    const fetchNonprofitData = async () => {
      try {
        const responses = await Promise.all(
          data?.["nearest nonprofits"]?.map(async (value) => {
            const response = await fetch(
              `${process.env.REACT_APP_FLASK_URL}/nonprofits/${value}`
            );
            return response.json();
          })
        );
        setNonprofitConnections(responses);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchCenterData = async () => {
      try {
        const responses = await Promise.all(
          data?.["nearest healthcenters"]?.map(async (value) => {
            const response = await fetch(
              `${process.env.REACT_APP_FLASK_URL}/healthcenters/${value}`
            );
            return response.json();
          })
        );
        setCenterConnections(responses);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCenterData();
    fetchNonprofitData();
  }, [data]);

  return (
    <div className="container detail-container">
      <div className="detail-header">
        {/* <img src={county.imageUrl} alt="county" className="header-image" /> */}
        <h1>{data?.name}</h1>
      </div>

      <div className="container d-flex flex-wrap gap-3 justify-content-center">
        <div className="county-stats-box">
          <h2>County Stats</h2>
          <div className="attributes">
            <b>Estimated Population (Past Year): </b>{" "}
            {Number(data?.total_population).toLocaleString()}
            <br />
            <b>Median Household Income: </b>{" "}
            {Number(data?.median_income).toLocaleString()}
            <br />
            <b>Unemployment Status: </b> {data?.unemployment}
            <br />
            <b>Health and Insurance Coverage: </b> {data?.health_coverage}
            <br />
            <b>Uninsured Population: </b>{" "}
            {Number(data?.["uninsured population"]).toLocaleString()}
            <br />
            <b>Health and Insurance Coverage: </b>
            {data?.health_coverage}
          </div>
        </div>
        <div className="county-map">
          <Map
            latitude={data?.latitude}
            longitude={data?.longitude}
            height="500px"
            width="500px"
          />
        </div>
      </div>

      <div className="county-description">
        <h2>Description: </h2>
        <p>{data?.description}</p>
      </div>

      <div className="connection-box">
        <h1 className="connection">Nonprofits Near {data?.name}</h1>
        <div className="container d-flex flex-wrap gap-3 justify-content-center">
          {nonprofitConnections?.map((nonprofit, index) => (
            <NonProfitCard key={index} nonprofit={nonprofit} />
          ))}
        </div>
      </div>
      <div className="connection-box">
        <h1 className="connection">Health Centers Near {data?.name}</h1>
        <div className="container d-flex flex-wrap gap-3 justify-content-center">
          {centerConnections.map((center, index) => (
            <CentersCard key={index} center={center[0]} />
          ))}
        </div>
      </div>
    </div>
  );
}
